module.exports = __webpack_public_path__ + "76946a5695d34d8750d0b3a27feb6565.MP3";